import { useCallback } from 'react'

import { deleteTrafficAreas } from '@/features/domain/traffic'
import { useIsUnmounted, useNotification } from '@/hooks'
import { useAppDispatch } from '@/store'
import { unproxify } from '@/utils'
import { resetCrudSelection } from '@/atoms'

import { useController } from './useController'
import { useTrafficProfile } from '../../../components/form/components/TrafficAreas/hooks/useTrafficProfile'

export function useDeleteTrafficAreas() {
  const {
    data: { trafficAreaIds },
    close,
  } = useController()
  const dispatch = useAppDispatch()
  const toast = useNotification()
  const trafficProfile = useTrafficProfile()
  const profileId = trafficProfile.id

  const isUnmounted = useIsUnmounted()

  return useCallback(async () => {
    try {
      const areaIds = unproxify(trafficAreaIds)

      const result = await dispatch(deleteTrafficAreas({ areaIds: areaIds, profileId }))

      if (isUnmounted()) return

      if (!deleteTrafficAreas.fulfilled.match(result)) {
        throw new Error(result.payload?.message ?? 'Internal error')
      }

      resetCrudSelection('trafficArea')
    } catch (e) {
      toast.error(e.message)
    } finally {
      close?.()
    }
  }, [dispatch, toast, trafficAreaIds, close, isUnmounted])
}
